var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccessPure(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.72539 27.9999C4.72539 15.1455 15.146 4.7249 28.0004 4.7249C40.8548 4.7249 51.2754 15.1455 51.2754 27.9999C51.2754 40.8543 40.8548 51.2749 28.0004 51.2749C15.146 51.2749 4.72539 40.8543 4.72539 27.9999ZM28.0004 0.524902C12.8264 0.524902 0.525391 12.8259 0.525391 27.9999C0.525391 43.1739 12.8264 55.4749 28.0004 55.4749C43.1744 55.4749 55.4754 43.1739 55.4754 27.9999C55.4754 12.8259 43.1744 0.524902 28.0004 0.524902ZM43.6137 18.8443C44.3562 17.9534 44.2358 16.6292 43.3448 15.8867C42.4538 15.1442 41.1296 15.2646 40.3871 16.1556L24.2907 35.4713L15.413 27.4006C14.5548 26.6205 13.2267 26.6837 12.4465 27.5419C11.6664 28.4001 11.7296 29.7282 12.5878 30.5084L23.0878 40.0538C23.5115 40.439 24.0742 40.6345 24.6454 40.5949C25.2167 40.5554 25.7471 40.2843 26.1137 39.8443L43.6137 18.8443Z",
    fill: "#47CC33"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessPure);
export default __webpack_public_path__ + "static/media/success-pure.db08977bb5202834a46d70ec31f09697.svg";
export { ForwardRef as ReactComponent };